import { render, staticRenderFns } from "./gamblers-gold-rules.vue?vue&type=template&id=46fb2c56&scoped=true&"
import script from "./gamblers-gold-rules.vue?vue&type=script&lang=js&"
export * from "./gamblers-gold-rules.vue?vue&type=script&lang=js&"
import style0 from "./gamblers-gold-rules.vue?vue&type=style&index=0&id=46fb2c56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fb2c56",
  null
  
)

export default component.exports